import React from 'react';
import { useAuth } from 'react-oidc-context';
import logo from '../assets/connect-plus-icon.png';

const Login: React.FC = () => {
  const auth = useAuth();

  const handleSignIn = async (): Promise<void> => {
    try {
      await auth.signinRedirect();
    } catch (error) {
      console.error('Login failed', error);
      alert('Aanmelden is mislukt. Probeer het opnieuw.');
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="w-full bg-neutral-100 border-b border-primary-600">
        <div className="max-w-7xl mx-auto py-4 flex items-center gap-4 px-8 xl:px-0">
          <img src={logo} alt="Company logo" className="h-10 w-10 object-contain" />
          <div className="text-lg font-semibold text-neutral-900">Athena</div>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center">
        <div className="text-center max-w-md mx-auto px-8">
          <img
            src={logo}
            alt="Company logo"
            className="h-20 w-20 object-contain mx-auto mb-8"
          />
          <h1 className="text-3xl font-bold text-primary-600 mb-3">Welkom bij Athena</h1>
          <p className="text-neutral-600 mb-8">
            Meld je aan met je account om de Connect+ tickets te bekijken en te stemmen.
          </p>
          <button
            onClick={handleSignIn}
            className="rounded-lg bg-primary-600 px-9 py-3 text-base font-medium text-white
              shadow transition hover:bg-primary-500 focus:outline-none focus:ring-2
              focus:ring-primary-500 focus:ring-offset-2"
          >
            Aanmelden
          </button>
        </div>
      </main>
    </div>
  );
};

export default Login;
